export default __webpack_public_path__ + "static/media/paula-freimane-offer-top.b9e8a7d2.png";